import { Product } from '../../../types';
import { ChangeEvent } from 'react';
import FormGroup from './FormGroup';
import * as React from 'react';

export type ItemEntryProps = Product & { onChange: (newValue: string) => void, disabled?: boolean };
export default function ItemEntry({
    itemNumber, itemName = '', onChange, disabled = false
}: ItemEntryProps): JSX.Element {
    function handleChange(event: ChangeEvent<HTMLInputElement>): void {
        onChange(event.target.value);
    }

    return (
        <>
        <FormGroup>
            <label>
                Item Number
                    <input type="number" value={itemNumber} min="1" onChange={handleChange} disabled={disabled} />
            </label>
        </FormGroup>
        <FormGroup>
            <label>
                Item Name
                    <input type="text" readOnly={true} value={itemName || ''} disabled={disabled} />
            </label>
        </FormGroup>
        </>
    );
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Alerts/form/ItemEntry.tsx